<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
import ButtonComponent from "@/components/Button/ButtonComponent.vue";
import Spinner from "@/components/parts/Spinner.vue";

const emit = defineEmits(["prev", "next"]);
// eslint-disable-next-line no-unused-vars
const props = defineProps({
    disabled: {
        type: Boolean,
        default: true,
    },
    backButtonText: {
        type: String,
        default: "Back",
    },
    nextButtonText: {
        type: String,
        default: "Next",
    },
    actionsStyles: {
        type: String,
        default: "",
    },
    fullWidth: {
        type: Boolean,
        default: false,
    },
    additionalBlockClass: {
        type: String,
        default: "",
    },
    showSpacer: {
        type: Boolean,
        default: false,
    },
    showNextButtonSpinner: {
        type: Boolean,
        default: false,
    },
});

</script>

<template>
    <div
        class="d-flex flex-column bottom-actions" data-test="footer"
    >
        <div
            class="d-flex flex-row"
            :class="{'col-9': !fullWidth, 'col-12': fullWidth}"
        >
            <div v-if="!fullWidth || showSpacer" :class="additionalBlockClass"></div>
            <div
                class="bottom-actions-container"
                :class="actionsStyles"
            >
                <div class="d-flex flex-row mt-3 justify-content-between">
                    <ButtonComponent
                        test-id="actions-prev-btn"
                        dataTest="btn-back"
                        @click="emit('prev')"
                        type="outline"
                    >
                        {{ props.backButtonText }}
                    </ButtonComponent>
                    <ButtonComponent
                        test-id="actions-next-btn"
                        dataTest="btn-next"
                        component-id="action_next_btn"
                        @click="emit('next')"
                        class="venues-btn-submit"
                        :class="{'disabled': props.disabled}"
                        type="primary"
                    >
                        {{ props.nextButtonText }}
                        <Spinner color="white" v-if="props.showNextButtonSpinner"/>
                    </ButtonComponent>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.bottom-actions-container {
    max-width: 100vw;
    height: 100%;
}

.pd-l0 {
    padding-left: 0;
}

.font-semibold {
    font-weight: 700;
}

</style>
